import { render, staticRenderFns } from "./Idle.vue?vue&type=template&id=fc93b642&"
import script from "./Idle.vue?vue&type=script&lang=js&"
export * from "./Idle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports